import axios from "@/plugins/axios";

export const state = () => ({
  shops: [],
  selected: null,
  shop_info: {},
  cashflow_summary: {},
});

export const mutations = {
  SET_SELECTED_SHOP(state, payload) {
    state.selected = payload;
  },
  SET_SHOPS(state, payload) {
    state.shops = payload;
  },
  SET_SHOP_INFO(state, payload) {
    state.shop_info = payload;
  },
  SET_CASHFLOW_SUMMARY(state, payload) {
    state.cashflow_summary = payload;
  },
};

export const actions = {
  async search({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/shops", payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchShops({ commit }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("pos/shops")
        .then((res) => {
          // ;
          commit("SET_SHOPS", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchShopInfo({ state, commit, getters }, payload = {}) {
    return new Promise((resolve, reject) => {
      commit("SET_SELECTED_SHOP", payload);
      axios
        .get("pos/shops/" + payload.id)
        .then((res) => {
          commit("SET_SHOP_INFO", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async fetchCashflowData({ state, commit, getters }, payload = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get("dashboard/shops/" + state.selected.id + "/summary")
        .then((res) => {
          commit("SET_CASHFLOW_SUMMARY", res.data.data);
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  async onCreateCashflow({ state, commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("cash-books", payload)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export const getters = {
  GetShopId(state) {
    return state.selected.id ? state.selected.id : null;
  },
  GetShopInfo(state) {
    return state.shop_info;
  },
  IsShopNull(state) {
    // ;
    return state.selected != null ? false : true;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
